import { Link, useRecordContext } from 'react-admin';

const ProductsLinkField = () => {
    const record = useRecordContext() as any;
    if (!record) {
        return null;
    }
    return (
        <Link
            to={`/ecom_categories/${record.categoryId}/ecom_product_templates/${record.id}/ecom_products`}
        >
            Products
        </Link>
    );
};

ProductsLinkField.defaultProps = {
    label: 'Products',
};

export default ProductsLinkField;
